import React from "react";
import { bool, node, number, oneOf, string } from "prop-types";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { classes } from "../utils/classes";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { sxClassName, sxProps, sxPropTypes } from "../props/sx";

const Box = ({
	className = "",
	borderRadius,
	borderWidth,
	borderColor,
	bgColor,
	indent = false,
	shadow = false,
	overflow,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	children,
	...props
}) => (
	<div
		className={classes(
			"box",
			indent && "box--indent",
			overflow && `overflow--${overflow}`,
			shadow && "box--shadow",
			...utilityClassName(
				deepMergeProps(
					{
						bgColor,
						radius: borderRadius,
						border: { width: borderWidth, color: borderColor },
					},
					pureProps(utility),
				),
			),
			...sxClassName(sx),
			...spacingClassName(spacing),
			className,
		)}
		{...props}
	>
		{children}
	</div>
);

Box.propTypes = {
	className: string,
	borderRadius: number,
	borderWidth: oneOf([1, 2, 3, 4]),
	borderColor: string,
	bgColor: string,
	overflow: oneOf(["hidden"]),
	indent: bool,
	shadow: bool,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
	children: node.isRequired,
};

export default Box;
